import { useQuery } from '@tanstack/react-query'

import { getCustomerAccountData } from './auth.service'

export const useCustomerAccountData = () =>
  useQuery({
    queryKey: ['customerAccountData'],
    queryFn: getCustomerAccountData,
    // Stale time is set to 12 hours so it only refreshes this data once or twice a day, it's not expected to update that often
    staleTime: 12 * 60 * 60 * 1000,
  })
